import React, { useState } from 'react';
import Dropdown from '../Dropdown';
import IconHorizontalDots from '../Icon/IconHorizontalDots';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/themes/material_blue.css'; // Import Flatpickr theme
import { useSelector } from 'react-redux';

function DashboardMonthFilter({ onOptionClick }) {
  const [selectedOption, setSelectedOption] = useState(null); // Track selected option
  const [dateRange, setDateRange] = useState([]); // Flatpickr date range
  const [confirmedDateRange, setConfirmedDateRange] = useState(null); // Confirmed date range
  const [isCustomOpen, setIsCustomOpen] = useState(false); // Toggle sub-dropdown for "Custom"
  const isRtl = useSelector((state) => state.themeConfig.rtlClass) === 'rtl'; // RTL check

  const handleClick = (option) => {
    setSelectedOption(option);
    if (onOptionClick) {
      onOptionClick(option); // Call the passed callback
    }
    if (option !== 'Custom') {
      setIsCustomOpen(false);
    }
  };

  const handleCustomClick = () => {
    setIsCustomOpen((prevState) => !prevState);
    setSelectedOption('Custom');
  };

  const handleCancel = () => {
    setDateRange([]); // Clear the selected date range
    setConfirmedDateRange(null); // Clear the confirmed date range
    setIsCustomOpen(false); // Close the custom date picker
  };

  const handleConfirm = () => {
    setConfirmedDateRange([...dateRange]); // Save the confirmed date range
    setIsCustomOpen(false); // Close the custom date picker
  };

  return (
    <>
      <div className="dropdown">
        <Dropdown
          offset={[0, 1]}
          placement={`${isRtl ? 'bottom-start' : 'bottom-end'}`}
          button={<IconHorizontalDots className="text-black/70 dark:text-white/70 hover:!text-primary" />}
        >
          <ul>
            <li>
              <button type="button" onClick={() => handleClick('daily')}>
                Daily
              </button>
            </li>
            <li>
              <button type="button" onClick={() => handleClick('weekly')}>
                Weekly
              </button>
            </li>
            <li>
              <button type="button" onClick={() => handleClick('monthly')}>
                Monthly
              </button>
            </li>
            <li>
              {/* <button type="button" onClick={() => handleClick('Qtly')}>
                Qtly
              </button>
            </li>
            <li>
              <button type="button" onClick={() => handleClick('Hfrly')}>
                Hfrly
              </button>
            </li>
            <li>
              <button type="button" onClick={() => handleClick('Yrly')}>
                Yrly
              </button>
            </li>
            <li>
              <button type="button" onClick={handleCustomClick}>
                Custom
              </button> */}
              {confirmedDateRange && (
                <div className="font-bold text-secondary mt-2 text-sm items-center p-2">
                  Range Selected : {confirmedDateRange[0]?.toLocaleDateString()} to {confirmedDateRange[1]?.toLocaleDateString()}
                </div>
              )}
            </li>
          </ul>
        </Dropdown>
      </div>

      {isCustomOpen && selectedOption === 'Custom' && (
        <div className="sub-dropdown" style={{ padding: '10px', border: '1px solid #ccc', background: '#f9f9f9' }}>
          <div className="date-range-picker">
            <h4>Select Date Range</h4>
            <Flatpickr
              options={{
                mode: 'range',
                dateFormat: 'm-d-Y',
                position: isRtl ? 'auto right' : 'auto left',
              }}
              value={dateRange}
              className="form-input border rounded p-2"
              placeholder="Select Date..."
              onChange={(dates) => setDateRange(dates)}
            />

            <div className="buttons" style={{ marginTop: '10px' }}>
              <button
                type="button"
                onClick={handleCancel}
                style={{
                  backgroundColor: 'red',
                  color: 'white',
                  padding: '8px 16px',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleConfirm}
                style={{
                  backgroundColor: 'blue',
                  color: 'white',
                  padding: '8px 16px',
                  border: 'none',
                  borderRadius: '4px',
                  marginLeft: '10px',
                  cursor: 'pointer',
                }}
              >
                Confirm
              </button>
            </div>

            {dateRange.length > 0 && (
              <div style={{ marginTop: '10px' }}>
                <strong>Selected Date Range:</strong>{' '}
                {dateRange.map((date, idx) => (
                  <span key={idx}>
                    {date.toLocaleDateString()} {idx === 0 ? 'to' : ''}
                  </span>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default DashboardMonthFilter;
